import type { Member } from '@wix/members-domain-ts';
import classNames from 'classnames';
import type { FC } from 'react';
import React from 'react';
import { Tooltip } from '@wix/wix-ui-tpa/cssVars';

import { MEMBERS_AREA_PAGE_TITLE_ID } from '../../../constants/common';
import {
  DEFAULT_HIDE_DELAY,
  DEFAULT_SHOW_DELAY,
} from '../../../constants/tooltip';
import type { InjectedClassNameProps } from '../../../types';
import styles from './MemberName.scss';

export interface MemberNameProps extends InjectedClassNameProps {
  name: string;
  member?: Member;
  tooltipClass?: string;
  goToMemberPage?: Function;
  htmlTag?: string;
}

const MemberName: FC<React.PropsWithChildren<MemberNameProps>> = ({
  name,
  className,
  tooltipClass,
  htmlTag = 'h1',
}) => {
  const HtmlTag = htmlTag as keyof JSX.IntrinsicElements;

  return (
    <Tooltip
      content={name}
      className={tooltipClass}
      showDelay={DEFAULT_SHOW_DELAY}
      hideDelay={DEFAULT_HIDE_DELAY}
      appendTo="window"
    >
      <HtmlTag
        aria-describedby={MEMBERS_AREA_PAGE_TITLE_ID}
        className={classNames(className, styles.nameButton)}
      >
        {name}
      </HtmlTag>
    </Tooltip>
  );
};

export default MemberName;
